"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.distinct = void 0;

var _any = require("../any/any");

var _deepEqual = require("../deep-equal/deep-equal");

/**
 * Remove repeating values
 *
 * @param {Array} source Source input array
 *
 * @return {Array}
 *
 * @name distinct
 * @tag Array
 * @signature (source: Array): Array
 *
 * @example
 * distinct([1, 1, 2])
 * // => [1, 2]
 */
var distinct = function distinct(source) {
  var result = [];

  for (var i = 0, length = source.length; i < length; i++) {
    var newElement = source[i];

    if ((0, _any.any)((0, _deepEqual.isDeepEqual)(newElement), result) === false) {
      result.push(newElement);
    }
  }

  return result;
};

exports.distinct = distinct;